import { getSpecialCalculationCosts } from '@/services/admin/special-calculation-costs';
import { SpecialCalculationCostQuery } from '@/types/special-calculation-cost';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useSpecialCalculationCostList = (query: SpecialCalculationCostQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['specialCalculationCosts', currentSite, query],
    queryFn: () => getSpecialCalculationCosts(currentSite, query),
    select: res => res.data,
  });
};
